<template>
  <div style="display: inline-block" >
<!--    新的组件(.vue文件） 中-->
<!--    <div id="he-plugin-simple"></div>-->
<!--    <iframe width="300" scrolling="no" height="25" frameborder="0" allowtransparency="true"-->
<!--            src="https://i.tianqi.com?c=code&amp;id=10&amp;color=%23FFFFFF&amp;icon=1&amp;py=fenxi&amp;site=12"-->
<!--            style="pointer-events: none;"></iframe>-->
<!--    <iframe width="300" height="40" src="https://i.tianqi.com/?c=code&a=getcode&id=11&icon=1&color=%23FFFFFF" frameborder="0"></iframe>-->
    <iframe width="300" height="40" src="https://i.tianqi.com/?c=code&a=getcode&id=34&icon=1&color=%23FFFFFF&py=hejin" frameborder="0"></iframe>
  </div>
</template>
 
<script>
export default {
  created() {  }
}
</script>

 
  <style>
 /* <script src="https://widget.qweather.net/simple/static/js/he-simple-common.js?v=2.0"></script> */
  </style>



